import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    intakeFormBackThunk,
    setIntakeFormSmsMarketingOptInThunk,
    submitIntakeFormThunk,
    updateIntakeFormPetThunk
} from 'actions/intakeForm/IntakeFormActions';
import { SmsMarketingConsent } from 'components/Customer/SmsMarketingConsent/SmsMarketingConsent';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { PetForm } from 'components/Pet/Form/PetForm';
import { PetOption } from 'components/Pet/Option/PetOption';
import { Button } from 'components/UI/Button/Button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getIntakeFormCustomer,
    getIntakeFormLoading,
    getIntakeFormPets
} from 'reducers/intakeForm/IntakeFormSelectors';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';
import { getSortedPaymentMethods } from 'reducers/paymentMethods/PaymentMethodsSelectors';
import { Pet } from 'types/Pet';
import { hasValidCardOnFile } from 'utils/paymentMethodUtils';
import classes from './IntakeFormPetList.module.scss';

export const IntakeFormPetList: React.FC = () => {
    const dispatch = useDispatch();
    const pets = useSelector(getIntakeFormPets);
    const isLoading = useSelector(getIntakeFormLoading);
    const customer = useSelector(getIntakeFormCustomer);
    const marketplace = useSelector(getMarketplace);
    const paymentMethods = useSelector(getSortedPaymentMethods);
    const willGoToCardOnFile =
        marketplace.settings.intakeFormCardOnFileEnabled && !hasValidCardOnFile(paymentMethods);

    const [editingPetUuid, setEditingPetUuid] = React.useState<string | null>(null);

    const editPetHandler = (uuid: string) => {
        setEditingPetUuid(uuid);
    };

    const editedPetHandler = async (pet: Pet) => {
        await dispatch(updateIntakeFormPetThunk(pet));

        setEditingPetUuid(null);
    };

    const addPetHandler = () => {
        dispatch(intakeFormBackThunk());
    };

    const submitHandler = () => {
        dispatch(submitIntakeFormThunk());
    };

    return (
        <LeftColumn
            footer={
                <div className={classes.footer}>
                    <SmsMarketingConsent
                        checked={!!customer.smsMarketingOptIn}
                        onChange={checked => dispatch(setIntakeFormSmsMarketingOptInThunk(checked))}
                    />

                    <Button
                        fullWidth
                        loading={isLoading}
                        disabled={pets.length === 0}
                        onClick={submitHandler}
                    >
                        {willGoToCardOnFile ? 'Continue' : 'Submit'}
                    </Button>
                </div>
            }
        >
            <h1 className="h1 underlined">Pets added</h1>

            {pets.map(pet => (
                <div key={pet.uuid} className="w-full">
                    {editingPetUuid === pet.uuid ? (
                        <PetForm
                            pet={pet as Pet}
                            showSubmitButton
                            className={classes.editForm}
                            submitButtonLabel="Update"
                            onSubmit={editedPetHandler}
                        />
                    ) : (
                        <PetOption hideCheckbox pet={pet} onEdit={() => editPetHandler(pet.uuid)} />
                    )}
                </div>
            ))}

            <Button variant="link" className={classes.addPetButton} onClick={addPetHandler}>
                <FontAwesomeIcon icon={faPlus} />

                <span>Add new pet</span>
            </Button>
        </LeftColumn>
    );
};
